<template>
  <div id="authorize">
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'signin',
  created () {
    this.signinCallback()
    //this.$showLoading()
  },
  methods: {
    ...mapActions('Auth', ['signinCallback'])
  }
}
</script>

<style lang="scss" scoped>

</style>
